import {HostListener, Inject, Injectable} from "@angular/core";
import {
    actionAccountCommandsRequest,
    actionAccountPollLiveChatRequest,
    actionAccountPollLiveChatV2Request,
    actionChangelistIdUpdate,
    actionCRUDRecordFailure,
    actionGetAccountDetails,
    actionGetAccountDetailsBillingToken,
    actionGetLocalStorageConfigServer,
    actionIndexHTMLStatics,
    actionLoadAccountRequest,
    actionLoadCartProductRequest,
    actionLoadOrdersRequest,
    actionLoadOS,
    actionLoadStationGeoIPRequest,
    actionLoadStationRequest,
    actionLoadTemplateRequest,
    actionLockRecordUpdate,
    actionPreloginResellerRequest,
    actionStationV2SocketUpdate,
    actionTwoFactorCheckAccess
} from "../store/actions/user.actions";
import * as websocket from 'websocket';
import {
    BehaviorSubject,
    from,
    fromEvent,
    interval,
    merge,
    Observable,
    of,
    share,
    Subject,
    Subscription,
    switchMap,
    throwError,
    timer
} from "rxjs";
import {StoreSelectorsService} from "./store-selectors.service";
import {
    EnumWizardUpgradeToasts,
    ExperienceLevelType,
    FileObj,
    IAppStatic,
    IChangeListIds,
    ICRUDRecord,
    ICRUDRecordRead,
    ICRUDRecordReadReply,
    ICRUDRecordReply,
    Id,
    ILockedRecords,
    IPlayerProps,
    IPreloadResellerInfo,
    IStaticIndexHTML,
    IStationStatsPropsV1V2,
    IUser,
    PlatformStatic,
    UploadStatus
} from "../interfaces";
import {EnumEnterpriseServerRequest, IEnterpriseReseller} from "../interfaces/enterprise-interface";
import {IAccountDetails} from "../interfaces/enterprise-account-interface";
import {IEnterpriseBusinesses} from "../interfaces/enterprise-businesses-interface";
import {actionEnterpriseRequest, actionEnterpriseRequestSocketNames} from "../store/actions/enterprise.actions";
import {bufferWhen, catchError, filter, map, skip, take, takeUntil, takeWhile, tap} from 'rxjs/operators';
import {LocalStoreService} from "./local-store.service";
import {
    dateUnixToString,
    DEFAULT_LIVE_CHAT_POLL,
    DEFAULT_LIVE_CHAT_POLL_V2,
    DEFAULT_LOAD_NET_DATA,
    DEFAULT_LOAD_NET_DATA_INIT,
    DEFAULT_SHOW_SALE_AD,
    DEFAULT_STATIONS_ENTERPRISE_POLL,
    DEFAULT_STATIONS_POLL,
    isEmbeddedWebSite,
    isHostLocal,
    isNullOrUndefOrEmpty,
    isSubscribersMode,
    NONE_VALUE,
    preprocessSceneRecord,
    PREVIOUSLY_USED_ACCOUNT,
    TOAST_FASTER,
    validateEmail,
    validateUrl
} from "../common";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {HttpClient} from "@angular/common/http";
import {PwaPromptService} from "./pwa-prompt.service";
import {Lib} from "../../libs/Lib";
import {DOCUMENT} from "@angular/common";
import {Platform} from '@angular/cdk/platform';
import {Compbaser} from "../components/compbaser";
import {timeout} from "../decorators/timeout";
import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';
import {OnSaleComponent} from "../components/on-sale/on-sale.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {UserService} from "./user.service";
import {retryWithBackoff} from "../../libs/rxjs/retryWithBackoff";
import {SwUpdate, VersionEvent} from "@angular/service-worker";
import {DialogVersionComponent} from "../components/dialog-version/dialog-version.component";
import {WizardUpgradeComponent} from "../containers/user/wizard-upgarde/wizard-upgrade.component";
import moment from "moment-timezone";
import {DialogEmailComponent} from "../components/dialog-email/dialog-email.component";
import {AccessService} from "./access-service";
import {ActionsSubject} from "@ngrx/store";
import {TwoFactorComponent} from "../containers/start/two-factor/two-factor.component";
import {ofType} from "@ngrx/effects";
import * as _ from 'lodash';
import {Router} from "@angular/router";

declare var platform: PlatformStatic;

const {version: version} = require('../../../package.json');
const {onSaleNow: onSaleNow} = require('../../../package.json');

@Injectable()
export class AppService extends Compbaser {
    user: IUser;
    preloginResellerInfo: IPreloadResellerInfo;
    pollStationSubs = [];
    clientSocket: WebSocket;
    appStatic: IAppStatic;
    resizeObservable$: Observable<Event>;
    resizeSubscription$: Subscription;
    u = _.uniqueId();
    debounceSyncStationsNamesEnterprise;
    debounceSyncStationsDomainsEnterprise;
    webSocketConnected = false;
    changelistIds: IChangeListIds;
    requestSync = false;
    accountDetails: IAccountDetails;

    private uploadingFiles = new BehaviorSubject<FileObj[]>(null);
    private uploadingStatus = new BehaviorSubject(null);
    private stopPolling = new Subject();
    private accountInitialCopyResources = 0;

    readonly experienceLevelType = ExperienceLevelType; // Expose enum to template
    experienceLevel: ExperienceLevelType;

    @HostListener('window:online')
    setNetworkOnline(): void {
        this.toastr.info(this.translocoService.translate('general.gainedNet', {}, this.translocoService.getActiveLang()));
    }

    @HostListener('window:offline')
    setNetworkOffline(): void {
        this.toastr.error(this.translocoService.translate('general.lostNet', {}, this.translocoService.getActiveLang()));
    }

    constructor(@Inject(DOCUMENT) private document: Document,
                private _http: HttpClient,
                private platformCDK: Platform,
                public override dialog: MatDialog,
                private actionsSubj: ActionsSubject,
                private accessService: AccessService,
                private breakpointObserver: BreakpointObserver,
                private userService: UserService,
                private storeSelector: StoreSelectorsService,
                private pwaPromptService: PwaPromptService,
                private localStoreService: LocalStoreService,
                private router: Router,
                private translocoService: TranslocoService,
                private toastr: ToastrService,
                private swUpdate: SwUpdate) {

        super(dialog);
        this.initOS();
        this.initService();
        this.pollLiveChat();
    }

    private initOS() {
        // require('platform');
        const info: any = platform.parse(platform.ua);
        const regex = RegExp('Edg');
        // if (platform?.name?.toLowerCase() === 'safari') {
        //     alert('Safari is not supported, please use Google Chrome');
        // }
        const os = {
            info,
            isBrowser: this.platformCDK.isBrowser,
            name1: platform.name,
            name2: info.name,
            family: platform.os.family,
            description1: platform.description,
            description2: info.description,
            uaSting: platform.ua,
            isEdge: regex.test(platform.ua),
            version: info.version,
            layout: info.layout,
            os: info.os
        };
        this.storeSelector.dispatch(actionLoadOS({os}));

        this.debounceSyncStationsNamesEnterprise = _.debounce((key) => {
            this.storeSelector
                .getBusinessesByDomain()
                .pipe(take(1))
                .subscribe((res) => {
                    this.storeSelector.dispatch(actionEnterpriseRequestSocketNames({callType: EnumEnterpriseServerRequest.STATION_DOMAIN_COLLECTION_SOCKET_NAMES, args: res}));
                });
        }, 100);

        this.debounceSyncStationsDomainsEnterprise = _.debounce((key) => {
            this.storeSelector
                .getBusinessesByDomain()
                .pipe(take(1))
                .subscribe((res) => {
                    this.storeSelector.dispatch(actionEnterpriseRequest({callType: EnumEnterpriseServerRequest.STATION_DOMAIN_COLLECTION, args: res}));
                });
        }, 3000);
    }

    private initService() {
        this.initLoadNetworkData();
        this.initPreloadReseller();
        this.loadIndexStatics();
        this.checkEquipment();
        this.cod(
            this.actionsSubj.pipe(
                ofType(actionTwoFactorCheckAccess),
                switchMap((payload) =>
                    interval(333).pipe(
                        switchMap(() => this.storeSelector.getTwoFactorState()
                            .pipe(take(1))),
                        takeWhile((v) => v !== null && v !== true),
                        tap((v) => {
                            if (this.dialog.openDialogs.length === 0) {
                                this.dialog.open(TwoFactorComponent, {
                                    width: '400px',
                                    disableClose: true,
                                    data: payload,
                                });
                            }
                        })
                    )
                )
            ).subscribe()
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                })
        );
        this.cod(
            this.storeSelector.getChangelistIds()
                .subscribe((i_changelistIds) => {
                    this.changelistIds = i_changelistIds;
                })
        );
        this.cod(
            this.storeSelector.getPreloginResellerInfo()
                .subscribe((i_preloginResellerInfo) => {
                    this.preloginResellerInfo = i_preloginResellerInfo;
                    // in future also add server support
                    this.localStoreService.setStorageValConfig('defaultLanguage', 'en');
                    this.localStoreService.setStorageValConfig('theme', String(i_preloginResellerInfo.theme_id));
                })
        );
        this.cod(
            this.storeSelector.getUser()
                .pipe(
                    filter((user) => {
                        if (Lib.IsAccessBlocked(user)) {
                            setTimeout(() => {
                                this.accountBlockedWarning(user);
                            }, 3000);

                        }
                        setTimeout(() => {
                            this.syncUser(user);
                        }, 5000);
                        if (!user.webApiResellerBaseUrl) {
                            return false;
                        } else {
                            return true;
                        }
                    }),
                    take(1)
                )
                .subscribe((user: IUser) => {
                    if (isSubscribersMode()) {
                        this.storeSelector.dispatch(actionGetAccountDetailsBillingToken({password: user.passwordNew}));
                        return;
                    }
                    this.initAccount(user);
                    if (!user.dashboard) {
                        this.initSocket();
                        this.pollResourcesReady();
                    }
                    this.initServices();

                    /** future support **/
                    // this.initListenOrientation();
                    // this.initListenResize();
                    // this.initUserInactivity();
                })
        );
        this.cod(
            this.storeSelector.getUserAccountDetails()
                .pipe(take(1))
                .subscribe((i_accountDetails: IAccountDetails) => {
                    this.accountDetails = i_accountDetails;
                    this.checkIfEmailExists();
                })
        );
        this.setUploadingStatus({
            percent: 1,
            show: false
        });
    }

    private findEmail(): string {
        if (validateEmail(this.accountDetails?.Account?.Shipping[0]?.$?.email)) {
            return this.accountDetails.Account.Shipping[0].$.email;
        }
        if (validateEmail(this.accountDetails?.Account?.Billing[0]?.$?.email)) {
            return this.accountDetails.Account.Billing[0].$.email;
        }
        if (validateEmail(this.accountDetails?.Account?.Contact[0]?.$?.email)) {
            return this.accountDetails.Account.Contact[0].$.email;
        }
        if (validateEmail(this.user?.username)) {
            return this.user.username;
        }
        if (validateEmail(this.user?.email)) {
            return this.user.email;
        }
        if (validateEmail(this.user?.name)) {
            return this.user.name;
        }
        return '';
    }

    private initPreloadReseller() {
        const resellerId = this.localStoreService.getItem('IPreloginReseller', '');
        if (!isNullOrUndefOrEmpty(resellerId)) {
            // this.localStoreService.setPreloginReseller(resellerId);
            this.storeSelector.dispatch(actionPreloginResellerRequest({isWhitelabel: resellerId}));
        }
    }

    private accountBlockedWarning(i_user: IUser) {
        if (isEmbeddedWebSite()) return;
        if (Lib.GetAccountVersion(i_user) === 'DASH') {
            return this.toastr.error('You account billing is out of date, please go to Accounts tab and enter a new credit card card to avoid screen disconnection', ' [ Avoid screens disconnection ]', {
                closeButton: true,
                disableTimeOut: true,
                positionClass: 'toast-top-center'
            });
        }
        if (Lib.GetAccountVersion(i_user) === 'ENTERPRISE_24' || Lib.GetAccountVersion(i_user) === 'ENTERPRISE_08') {
            return this.toastr.error('You account is under a reseller which is currently inactive. Contact your admin or login to Studio-Dashboard to update billing information under that enterprise account.', ' [ Avoid screens disconnection ]', {
                closeButton: true,
                disableTimeOut: true,
                positionClass: 'toast-top-center'
            });
        }
        if (Lib.GetAccountVersion(i_user) === 'PLUS') {
            return this.toastr.error('your account is inactive due to outdated billing and credit card info. please update under the Account tab to avoid screen disconnection', ' [ Alert ]', {
                closeButton: true,
                disableTimeOut: true,
                positionClass: 'toast-top-center'
            });
        }
    }

    private initLoadNetworkData() {
        this.storeSelector.dispatchStaggered([
            actionLoadTemplateRequest({}),
            actionLoadCartProductRequest('')
        ], DEFAULT_LOAD_NET_DATA_INIT, DEFAULT_LOAD_NET_DATA);
    }

    private initListenResize() {
        this.resizeObservable$ = fromEvent(window, 'resize');
        this.resizeSubscription$ = this.resizeObservable$
            .subscribe((evt) => {
                console.log(`resizeEvent: ${evt.target['innerWidth']} ${evt.target['innerHeight']}`);
            });
    }

    private initListenOrientation() {
        this.breakpointObserver
            .observe(['(min-width: 900px)'])
            .subscribe((state: BreakpointState) => {
                if (state.matches) {
                    console.log('Viewport is 900px or over!');
                } else {
                    console.log('Viewport is smaller than 900px!');
                }
            });
        const layoutChanges = this.breakpointObserver.observe([
            '(orientation: portrait)',
            '(orientation: landscape)',
        ]);
        layoutChanges.subscribe(result => {
            console.log('orient change');
        });
    }

    private initUserInactivity() {
        const perMinute$ = interval(60000_000);
        const events$ = merge(
            fromEvent(document.body, 'click'),
            fromEvent(document.body, 'mousemove'),
            fromEvent(document.body, 'scroll'),
        );
        this.cod(
            events$.pipe(
                bufferWhen(() => perMinute$),
                filter(events => events.length === 0),
            ).subscribe(() => {
                console.log('You have been inactive for a minute, logging out...');
            })
        );
    }

    private initServices() {
        /** Dashboard **/
        this.cod(
            this.storeSelector.getEnterpriseReseller()
                .pipe(take(1))
                .subscribe((enterprise: IEnterpriseReseller) => {
                    this.storeSelector.dispatch(actionEnterpriseRequest({callType: EnumEnterpriseServerRequest.ACCOUNT_DETAILS}));
                })
        );
        this.cod(
            this.storeSelector.getEnterpriseAccDetails()
                .pipe(take(1))
                .subscribe((enterprise: IAccountDetails) => {
                    this.storeSelector.dispatch(actionEnterpriseRequest({callType: EnumEnterpriseServerRequest.BUSINESSES_INFO}));
                })
        );
        this.cod(
            this.storeSelector.getEnterpriseBusinesses()
                .pipe(take(1))
                .subscribe((enterprise: IEnterpriseBusinesses) => {
                    this.debounceSyncStationsNamesEnterprise();
                    this.debounceSyncStationsDomainsEnterprise();
                    this.storeSelector.dispatch(actionEnterpriseRequest({
                        callType: EnumEnterpriseServerRequest.BUSINESS_USERS,
                        args: enterprise.Businesses.BusinessInfo
                    }));
                })
        );
    }

    private initAccount(i_user: IUser) {
        this.user = i_user;
        /** Dashboard **/
        if (this.user.dashboard) {
            this.storeSelector.dispatchStaggered([
                actionEnterpriseRequest({callType: EnumEnterpriseServerRequest.RESELLER_INFO}),
                actionLoadOrdersRequest({})
            ], 333, 2500);
        } else {
            /** User **/
            this.storeSelector.dispatchStaggered([
                actionGetLocalStorageConfigServer({val: this.user}),
                actionLoadAccountRequest({businessId: this.user.businessId, changelistId: NONE_VALUE}),
                actionGetAccountDetails(''),
                actionLoadOrdersRequest({})
            ], 333, 2000);
            this.syncUser(this.user);
            this.syncStationsUser();
        }
        // this.storeSelector.dispatchStaggered([
        //     actionLoadTrackingStationRequest({globalDataRequest: null}),
        //     actionLoadTrackingStationStatsRequest({globalDataRequest: null})
        // ], 1500, 2000);
    }

    /** get extra station data as Geo stats and tracking details **/
    private getStationsExtras() {
        this.cod(
            this.storeSelector.getStationStats()
                .pipe(
                    // filter((v) => v.length !== 0),
                    // delay(1000),
                    take(1)
                ).subscribe((v) => {
                if (this.user.dashboard) {
                    this.storeSelector.dispatch(actionEnterpriseRequest({
                        callType: EnumEnterpriseServerRequest.STATION_COLLECTION_GEOIP,
                        args: []
                    }));
                } else {
                    this.storeSelector.dispatch(actionLoadStationGeoIPRequest({}));
                }
            })
        );
    }

    private checkEquipment() {
        if (!this.localStoreService) return;
        if (this.localStoreService.getStorageConfig()?.equipmentPwa === '1') {
            console.log('redirecting to /shopping-cart/equipment');
            this.router.navigateByUrl('/shopping-cart/equipment');
        }
    }

    private loadIndexStatics() {
        const staticIndexHTML: IStaticIndexHTML = {language: null, resellerStaticId: null};
        try {
            staticIndexHTML.resellerStaticId = Number(this.document.head.querySelector("[property~=enterprise][id]")['id']);
        } catch (e) {
        }
        try {
            staticIndexHTML.language = this.document.head.querySelector("[property~=language][id]")['id'];
        } catch (e) {
        }
        this.storeSelector.dispatch(actionIndexHTMLStatics({staticIndexHTML}));
        // if wanted to load it from package json instead
        // this._http.get<any>(`${this.appSettings.globalService}/${HOST_DIR}/package.json`).pipe(take(1)).subscribe((r) => {
        //     console.log(`reseller id: ${r.resellerId}`);
        // });
    }

    private syncStationsUser() {
        if (!this.user) return;
        this.storeSelector.dispatch(actionLoadStationRequest({businessId: this.user.businessId}));
    }

    @timeout(1000)
    public reloadBusinessUser() {
        this.storeSelector.getEnterpriseBusinesses()
            .pipe(skip(1), take(1))
            .subscribe((enterprise: IEnterpriseBusinesses) => {
                this.storeSelector.dispatch(actionEnterpriseRequest({
                    callType: EnumEnterpriseServerRequest.BUSINESS_USERS,
                    args: enterprise.Businesses.BusinessInfo
                }));
            });
        this.storeSelector.dispatch(actionEnterpriseRequest({callType: EnumEnterpriseServerRequest.BUSINESSES_INFO}));
    }

    public pwaOpenInstaller() {
        const pwaHideInstaller = this.localStoreService.getStorageValConfig('pwaHideInstaller');
        if (pwaHideInstaller === '1') return;
        this.experienceLevel = this.localStoreService.getStorageValConfig('experienceLevel'); // Alon
        if (this.experienceLevel == ExperienceLevelType.BEGINNER) return;
        this.pwaPromptService.pwaAutoOpenPrompt();
    }

    public initOnSale() {
        timer(DEFAULT_SHOW_SALE_AD)
            .pipe(take(1))
            .subscribe(time => {
                if (Lib.DevMode()) return;
                if (!this.user || this.user.enterprise === true) return;
                if (onSaleNow.length < 2 || onSaleNow === this.localStoreService.getStorageConfig().onSaleShown) return;
                this.openOnSaleDialog();
            });
    }

    public openOnSaleDialog() {
        this.dialog.open(OnSaleComponent, {width: '1200px'});
    }

    private checkIfEmailExists() {
        if (isNullOrUndefOrEmpty(this.user)) return;
        const email = this.findEmail();
        if (!isNullOrUndefOrEmpty(email)) return;
        if (Lib.GetAccountVersion(this.user) === 'FREE') {
            this.openEmailDialog();
        } else {
            this.cod(
                this.accessService.getGroupsCollection("SignStudio Dashboard")
                    .pipe(map((value) => value))
                    .pipe(take(1),
                        map((value) => {
                            return value?.$?.resellerCollectUserEmail ? value.$.resellerCollectUserEmail : '0';
                        })
                    ).subscribe((v) => {
                    if (v === '1') {
                        this.openEmailDialog();
                    }
                })
            );
        }
    }

    private openEmailDialog() {
        const dialogRef = this.dialog.open(DialogEmailComponent, {
            width: '400px'
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {

            }
        });
    }

    /** sync user details **/
    public syncUser(i_user?: IUser) {
        if (!i_user) i_user = this.user;
        if (!i_user.username) return;
        if (isNullOrUndefOrEmpty(i_user.username)) return;
        if (i_user.username === 'none') return;
        this.storeSelector.appStore.dispatch(actionAccountCommandsRequest({
                accountRequest: {
                    verifyAccount: {
                        userName: i_user.username,
                        password: i_user.passwordNew,
                        rememberMe: i_user.rememberMe
                    },
                    serverCall: "SYNC_USER"
                }
            })
        );
    }

    /** when a fresh account is opened we have to wait for resources to get copied over on aws / server side
     * we block for a bit until we see that total resources in account has not changed thus we know all
     * resources have been copied over to new account and user can begin using it **/
    private pollResourcesReady() {
        // this.localStoreService.setStorageValConfig('accountInitialCopyResources', '0');
        // return;
        const initAccountResourcesCount = this.localStoreService.getStorageConfig().accountInitialCopyResources;
        /** if -1 it is a previously used account so no need to check server copy on resources **/
        if (initAccountResourcesCount === PREVIOUSLY_USED_ACCOUNT) return;
        let counter = 0;
        const url = `${this.user.webApiBaseUrl}/Web/getResourceCount.ashx?businessId=${this.user.businessId}`;
        const r$ = timer(1, 2000)
            .pipe(
                switchMap((a) => this._http.get<any[]>(url)),
                retryWithBackoff(url, this.storeSelector, this.toastr),
                catchError((err) => {
                    console.error('accountInitialCopyResources error ' + err);
                    // this.toastr.error('No resources, is this a Studio legacy account?');
                    return throwError(err);
                }),
                share(),
                takeUntil(this.stopPolling)
            ).subscribe((v: any) => {
                counter++;
                /** if no change in total resources copied on sever means the account is ready, or if too much time has passed account is ready **/
                if (counter > 50 || v?.count === this.accountInitialCopyResources) {
                    setTimeout(() => {
                        this.stopPolling.next(null);
                        this.localStoreService.setStorageValConfig('accountInitialCopyResources', PREVIOUSLY_USED_ACCOUNT);
                    }, 7000);
                } else {
                    this.accountInitialCopyResources = v.count;
                    this.localStoreService.setStorageValConfig('accountInitialCopyResources', this.accountInitialCopyResources);
                }
            });
    }

    private initSocket() {
        this.clientSocket = new websocket.w3cwebsocket(`wss://${this.user.businessDomain}/Web/studioWebSocket.ashx`);

        this.clientSocket.onerror = (err) => {
            this.resetStationsSockets();
            this.stationSocketTeardown();
            Lib.DevShow('ws: err ' + err);
        };

        this.clientSocket.onopen = () => {
            // Lib.DevShow('ws: connected');
            if (this.clientSocket.readyState === this.clientSocket.OPEN) {
                this.resetStationsSockets();
                const msg = {
                    businessId: this.user.businessId,
                    studioId: this.localStoreService.getStorageConfig().studioId,
                    command: 'registerStudio'
                };
                this.clientSocket.send(JSON.stringify(msg));
            }
        };

        this.clientSocket.onclose = () => {
            this.resetStationsSockets();
            this.stationSocketTeardown();
        };

        this.clientSocket.onmessage = (e) => {
            let socketReply;
            if (typeof e.data === 'string') {
                // Lib.DevShow('ws: ' + e.data);
                try {
                    socketReply = JSON.parse(e.data);
                    if (socketReply && socketReply.players && socketReply.players.length > 0) {
                        socketReply.players.forEach((_player: IStationStatsPropsV1V2) => {
                            const value: IStationStatsPropsV1V2 = {
                                connection: _player.connected,
                                playing: _player?.playing,
                                wdConnected: _player?.wdConnected,
                                wdNative: _player?.wdNative,
                                wdExtension: _player?.wdExtension,
                                libVersion: _player?.libVersion,
                                appVersion: _player?.appVersion,
                                localIp: _player?.userHostAddress,
                                platform: _player?.platform
                            };

                            if (_player?.startTime && !_.isNull(parseInt(_player?.startTime))) {
                                value['startTime'] = dateUnixToString(_player?.startTime, -3, 'MM-DD-YY HH:mm:ss');
                            }
                            if (_player?.lastUpdate && !_.isNull(parseInt(_player?.lastUpdate))) {
                                const now = moment().unix();
                                const last = Number(_player?.lastUpdate);
                                const final: any = now - last;
                                value['lastUpdate'] = final;
                                // value['lastUpdate'] = moment(_player.lastUpdate).format('MM-DD-YY HH:mm:ss');
                            }
                            this.storeSelector.dispatchStaggered([actionStationV2SocketUpdate({
                                id: _player.playerId,
                                businessId: this.user.businessId,
                                version: '2',
                                value
                            })], 0, 1000);
                        });
                    }
                    if (!socketReply.studios) {
                        return;
                    }
                } catch (e) {
                    this.toastr.error(this.translocoService.translate('general.problemSocket', {}, this.translocoService.getActiveLang()));
                    return;
                }

                /** save interrupted by another user so we re-sync account data so we can merge it  **/
                if (socketReply.sender !== this.localStoreService.getStorageConfig().studioId) {
                    if (this.changelistIds.changelistIdSocket !== socketReply.studios.changelistId) {
                        this.requestSync = true;
                        this.syncAccount();
                    }
                } else {
                    /** this studio saves **/
                    this.requestSync = false;
                    this.storeSelector.dispatch(actionChangelistIdUpdate({payload: {changelistId: socketReply.studios.changelistId}}));
                }

                if (socketReply.studios != null) {
                    const lockedRecords: Array<ILockedRecords> = [];
                    Object.keys(socketReply.studios.lockedRecords).forEach((k) => {
                        const lockId = socketReply.studios.lockedRecords[k];
                        const v = k.split('.');
                        lockedRecords.push({
                            lockId,
                            tableId: v[1],
                            table: v[0]
                        });
                    });
                    this.storeSelector.dispatch(actionLockRecordUpdate({
                        payload: {
                            changelistId: socketReply.studios.changelistId,
                            lockedRecords
                        }
                    }));
                }
            }
        };

        this.webSocketConnected = true;
    }

    private stationSocketTeardown() {
        console.log('station socket teardown, reconnecting...');
        this.webSocketConnected = false;
        if (this.clientSocket) {
            this.clientSocket.close();
            this.clientSocket.removeAllListeners();
        }
        this.clientSocket = null;
        setTimeout(() => {
            this.initSocket();
        }, 3000);
    }

    public syncAccount() {
        this.storeSelector.dispatchStaggered([
            actionLoadAccountRequest({
                businessId: this.user.businessId,
                changelistId: this.changelistIds.changelistIdSync
            }),
            actionLoadStationRequest({businessId: this.user.businessId})
        ], null, 2000);
    }

    public syncStations() {
        if (this.user.dashboard) {
            this.syncStationsEnterprise();
        } else {
            this.syncStationsUser();
        }
    }

    public syncStationsEnterprise() {
        this.debounceSyncStationsNamesEnterprise();
        this.debounceSyncStationsDomainsEnterprise();
    }

    public stopPollStations() {
        this.pollStationSubs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    public stationSocketPing() {
        try {
            const msg = {
                businessId: this.user.businessId,
                studioId: this.localStoreService.getStorageConfig().studioId,
                command: 'pingPlayers'
            };
            if (!this.clientSocket ||
                this.clientSocket.readyState === this.clientSocket.CONNECTING ||
                this.clientSocket.readyState === this.clientSocket.CLOSED) {
                return;
            }
            this.clientSocket.send(JSON.stringify(msg));
        } catch (err) {
            console.error('problem sending clientSocket ' + err);
        }
    }

    public goToHomePage(popUp: boolean = false) {
        let url;
        if (this.user?.enterprise) {
            url = `${this.user?.customStudio?.Studio?.Application?.[0]?.Links?.[0]?.$?.home}`;
        } else if (this?.preloginResellerInfo) {
            url = `${this.preloginResellerInfo?.custom_studio_json?.Application?.[0]?.Links?.[0]?.$?.home}`;
        } else {
            url = this.appStatic.homePage;
        }
        url = validateUrl(url);
        if (url === null) {
            url = this.appStatic.homePage;
        }
        if (popUp) {
            window.open(url, "_blank");
        } else {
            window.location.href = url;
        }
    }

    // emulation mode only for socket stations version 2
    public socketStations() {
        const TIMEOUT = this.user.dashboard ? DEFAULT_STATIONS_ENTERPRISE_POLL : DEFAULT_STATIONS_POLL;
        const s = timer(1000, TIMEOUT)
            .subscribe(val => {
                if (this.user.dashboard) {
                    this.debounceSyncStationsNamesEnterprise();
                    this.debounceSyncStationsDomainsEnterprise();
                } else {
                    this.syncStationsUser();
                }
                this.getStationsExtras();
            });
        this.pollStationSubs.push(s);
    }

    public pollStations() {
        let TIMEOUT = DEFAULT_STATIONS_POLL;
        if (this?.user?.dashboard) {
            TIMEOUT = DEFAULT_STATIONS_ENTERPRISE_POLL;
        }
        const s = timer(2000, TIMEOUT)
            .subscribe(val => {
                if (this?.user?.dashboard) {
                    this.debounceSyncStationsNamesEnterprise();
                    this.debounceSyncStationsDomainsEnterprise();
                } else {
                    this.syncStationsUser();
                }
                this.getStationsExtras();
            });
        this.pollStationSubs.push(s);
    }

    public pollLiveChat() {
        const s1 = timer(1000, DEFAULT_LIVE_CHAT_POLL).subscribe(val => {
            this.storeSelector.dispatch(actionAccountPollLiveChatRequest(''));
        });
        const s2 = timer(1, DEFAULT_LIVE_CHAT_POLL_V2).subscribe(val => {
            this.storeSelector.dispatch(actionAccountPollLiveChatV2Request(''));
        });
    }

    public checkAppVersion(): Promise<VersionEvent> {
        return new Promise((resolve, reject) => {
            if (isHostLocal()) return resolve(null);
            console.log('checking for latest version studio');
            this.swUpdate.versionUpdates.subscribe((evt) => {
                console.log('UpdateService: versionUpdates', evt);
                switch (evt.type) {
                    case 'VERSION_DETECTED':
                        console.log(`Downloading new app version: ${evt.version.hash}`);
                        break;
                    case 'VERSION_READY':
                        console.log(`Current app version: ${evt.currentVersion.hash}`);
                        console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
                        resolve(evt);
                        break;
                    case 'VERSION_INSTALLATION_FAILED':
                        console.log(`Failed to install app ver '${evt.version.hash}': ${evt.error}`);
                        reject(`Failed to install app ver '${evt.version.hash}': ${evt.error}`);
                        break;
                }
            });
        });
    }

    announceNewVersion(i_version) {
        const ref = this.dialog.open(DialogVersionComponent, {
            width: '500px',
            height: '360px',
            data: i_version
        });
        ref.afterClosed().subscribe(async (v) => {
            if (v) {
                await this.activateUpdate();
            }
        });
    }

    public async activateUpdate() {
        await this.swUpdate.activateUpdate();
        location.reload();
    }

    unCacheApp(): Observable<any> {
        console.log('checking sw-cache');
        if ('caches' in window) {
            return from(caches.keys()
                .then((keyList) => {
                    return Promise.all(keyList.map((key) => {
                        console.log('deleting cache ' + key);
                        return caches.delete(key);
                    }));
                })
            );
        } else {
            return of(false);
        }
    }

    unregisterSW(): Observable<any> {
        return new Observable<any>(sub => {
            if (window.navigator && navigator.serviceWorker) {
                navigator.serviceWorker.getRegistrations()
                    .then((registrations) => {
                        for (const registration of registrations) {
                            console.log('unregistering service worker');
                            registration['unregister']();
                        }
                        console.log('unregisterSW finish');
                        sub.next(true);
                        sub.complete();
                    });
            } else {
                sub.next(false);
                sub.complete();
            }
        });
    }


    public installPwa() {
        this.pwaPromptService.pwaManuallyOpenPrompt();
    }

    public async crudRecord(saveRecord: ICRUDRecord): Promise<ICRUDRecord> {
        return new Promise((res, err) => {
            this.userService.crudRecord(saveRecord)
                .pipe(
                    map((i_reply: ICRUDRecordReply) => {
                        saveRecord.command = "reply";
                        saveRecord.serverReply = i_reply;
                        return res(saveRecord);
                    }),
                    catchError((i_error) => {
                        console.log(`actionCRUDRecordFailure ${i_error.message}`);
                        saveRecord.command = "reply";
                        saveRecord.serverReply = {id: null, status: false};
                        err(saveRecord);
                        return of(actionCRUDRecordFailure({
                            saveRecord: {
                                studioId: null,
                                command: "reply",
                                body: i_error,
                                serverReply: {status: false, id: null}
                            }
                        }));
                    })
                ).subscribe();
        });
    }

    public async crudRecordRead(readRecord: ICRUDRecordRead): Promise<ICRUDRecordReadReply> {
        return new Promise((res, err) => {
            this.userService.crudRecordReadCall(readRecord)
                .pipe(
                    map((i_reply) => {
                        // console.log(i_reply);
                        // saveRecord.command = "reply";
                        // saveRecord.serverReply = i_reply;
                        return res(i_reply);
                    }),
                    catchError((i_error) => {
                        console.log(`actionCRUDRecordReadFailure ${i_error.message}`);
                        // saveRecord.command = "reply";
                        // saveRecord.serverReply = {id: null, status: false};
                        err(readRecord);
                        return of(actionCRUDRecordFailure({
                            saveRecord: {
                                studioId: null,
                                command: "reply",
                                body: i_error,
                                serverReply: {status: false, id: null}
                            }
                        }));
                    })
                ).subscribe();
        });
    }

    public updateMultiScene(sceneIds: Id[], showMessage = null) {
        if (!sceneIds || sceneIds.length === 0) return;
        sceneIds.forEach((_sceneId) => {
            this.storeSelector.getScene(_sceneId).pipe(take(1)).subscribe((scene: IPlayerProps) => {
                if (!scene) return;
                const saveRecord = preprocessSceneRecord(scene, _sceneId, this.localStoreService.getStorageConfig().studioId, 'update');
                this.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
                    if (showMessage) {
                        if (!i_crudReply.serverReply.status) {
                            this.toastr.error(this.translocoService.translate('toast.failedSave', {}, this.translocoService.getActiveLang()));
                        } else {
                            this.toastr.info(this.translocoService.translate('toast.successSave', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
                        }
                    }
                });
            });
        });
    }

    public resetStationsSockets() {
        this.storeSelector.getStationStats().pipe(take(1))
            .subscribe((i_stationStats) => {
                i_stationStats.forEach((_player) => {
                    if (_player.$.connection === '0') return;
                    if (_player.$.version !== '2') return;
                    const value = {
                        connection: '0',
                        playing: '0',
                        wdNative: '',
                        wdConnected: '',
                        wdExtension: '',
                        libVersion: '',
                        appVersion: '',
                        localIp: '',
                        platform: '',
                        lastUpdate: moment(Date.now()).format('MM-DD-YY HH:mm:ss')
                    };
                    this.storeSelector.dispatchStaggered([actionStationV2SocketUpdate({
                        id: _player.$.id,
                        businessId: this.user.businessId,
                        version: '2',
                        value
                    })], 0, 1);
                });
            });
    }

    public lockRecord(sceneId) {
        const saveRecord: ICRUDRecord = {
            studioId: this.localStoreService.getStorageConfig().studioId,
            command: 'edit',
            primary: 'player_data_id',
            table: 'player_data',
            body: {},
            id: sceneId
        };
        this.crudRecord(saveRecord).then((i_crudReply: ICRUDRecord) => {
            if (!i_crudReply.serverReply.status) {
                this.toastr.error(this.translocoService.translate('toast.failedSave', {}, this.translocoService.getActiveLang()));
            }
        });
    }

    public async uploadFileWithProcess(saveRecord: ICRUDRecord, _callback = null) {
        return new Promise((resolve) => {
            this.userService.crudRecord(saveRecord)
                .pipe(
                    map((i_reply: ICRUDRecordReply) => {
                        if (i_reply && i_reply.hasOwnProperty('type') && i_reply.hasOwnProperty('status') == false) {
                            saveRecord.command = "progress";
                        } else {
                            saveRecord.command = "reply";
                        }
                        saveRecord.serverReply = i_reply;
                        return saveRecord;
                    }),
                    catchError((i_error) => {
                        return of(actionCRUDRecordFailure({
                            saveRecord: {
                                studioId: null,
                                command: "reply",
                                body: i_error,
                                serverReply: {status: false, id: null}
                            }
                        }));
                    })
                ).subscribe((result) => {
                if (_callback) _callback(result);
            });
        });
    }

    public setUploadingStatus(status = null, files = null) {
        if (!status) {
            if (!files) return;

            let uploadedSize = 0;
            let totalSize = 0;

            for (const fileObj of files) {
                uploadedSize += fileObj.fileSize * fileObj.progress;
                totalSize += fileObj.fileSize;
            }

            this.uploadingStatus.next({
                percent: Math.round(uploadedSize / totalSize),
                show: true
            });
        } else {
            this.uploadingStatus.next(status);
        }
    }

    public getUploadingStatus(): Observable<any> {
        return this.uploadingStatus;
    }

    public setUploadingFiles(files: FileObj[] = []) {
        this.uploadingFiles.next(files);

        if (this.uploadingFiles.value.length == 0) {
            this.setUploadingStatus({
                percent: 0,
                show: false
            });
        }
    }

    public openWizardUpgradeDialog(toast: EnumWizardUpgradeToasts = null, height = '800px', width = '800px', showCloseButton = true): MatDialogRef<WizardUpgradeComponent> {
        return this.dialog.open(WizardUpgradeComponent, {height, width, disableClose: true, data: {toast, showCloseButton}});
    }

    public getUploadingFiles(): Observable<FileObj[]> {
        return this.uploadingFiles;
    }

    public uploadResourceFiles() {
        this.setUploadingStatus({
            percent: 0,
            show: true
        });

        const validUploadFiles = this.uploadingFiles.value.filter((fileObj) =>
            fileObj.uploadStatus == UploadStatus.READY || fileObj.uploadStatus == UploadStatus.FAILED
        );

        for (const fileObj of validUploadFiles) {

            const file: File = fileObj.file;
            const formData = new FormData();
            formData.append("thumbnail", file);

            const saveRecord: ICRUDRecord = {
                studioId: this.localStoreService.getStorageConfig().studioId,
                command: 'upload',
                primary: 'resource_id',
                table: 'resources',
                body: formData,
                id: null,
                options: {noStringify: true, reportProgress: true},
            };

            this.uploadFileWithProcess(saveRecord, (i_crudReply) => {
                const reply = i_crudReply.serverReply;
                if (i_crudReply.command == 'progress' || (reply.hasOwnProperty('type') && reply.hasOwnProperty('body') == false)) {
                    if (reply['type'] == '1' && reply['total']) {
                        const percent = Math.round(100 * parseFloat(reply['loaded']) / parseFloat(reply['total']));
                        if (percent < 100) {
                            fileObj.progress = percent;
                        } else {
                            fileObj.progress = 100;
                        }
                    }
                    fileObj.uploadStatus = UploadStatus.INPROGRESS;
                } else {
                    if (!reply.status) {
                        fileObj.progress = 0;
                        fileObj.uploadStatus = UploadStatus.FAILED;
                    } else {
                        fileObj.progress = 100;
                        fileObj.uploadStatus = UploadStatus.SUCCESS;
                        fileObj.fileId = reply['body'].id;
                    }
                }
                this.setUploadingStatus(null, validUploadFiles);
                this.setUploadingFiles(this.uploadingFiles.getValue());
            });
        }
    }
}


